const RenderDebugOverlay = () => null;

export default RenderDebugOverlay;
